var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCaLarge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 63 58",
    style: {
      enableBackground: "new 0 0 63 58"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EF404C;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63,0v58H0V0H63z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44,18h10c0.8,0,1.5-0.7,1.5-1.5S54.8,15,54,15h-6.4L55,7.6c0.6-0.6,0.6-1.5,0-2.1s-1.5-0.6-2.1,0l-7.4,7.4 V6.5C45.5,5.7,44.8,5,44,5s-1.5,0.7-1.5,1.5v10C42.5,17.3,43.2,18,44,18L44,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.5,16.5C7.5,17.3,8.2,18,9,18l0,0h10c0.8,0,1.5-0.7,1.5-1.5l0,0v-10C20.5,5.7,19.8,5,19,5s-1.5,0.7-1.5,1.5 v6.4l-7.4-7.4C9.5,4.9,8.6,4.9,8,5.5S7.4,7,8,7.6l7.4,7.4H9C8.2,15,7.5,15.7,7.5,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.5,41.5c0-0.8-0.7-1.5-1.5-1.5H44c-0.8,0-1.5,0.7-1.5,1.5v10c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5v-6.4 l7.4,7.4c0.3,0.3,0.7,0.4,1.1,0.4c0.4,0,0.8-0.2,1.1-0.4c0.6-0.6,0.6-1.5,0-2.1l0,0L47.6,43H54C54.8,43,55.5,42.3,55.5,41.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19,40H9c-0.8,0-1.5,0.7-1.5,1.5S8.2,43,9,43h6.4L8,50.4c-0.6,0.6-0.6,1.5,0,2.1l0,0c0.3,0.3,0.7,0.4,1.1,0.4 s0.8-0.2,1.1-0.4l7.4-7.4v6.4c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5v-10C20.5,40.7,19.8,40,19,40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.6,35.2L33.4,13.9c-0.6-1-1.9-1.4-2.9-0.8c-0.3,0.2-0.6,0.5-0.8,0.8L17.4,35.2c-0.4,0.7-0.2,1.6,0.5,2 c0.2,0.1,0.5,0.2,0.7,0.2h25.8c0.8,0,1.4-0.6,1.4-1.4C45.8,35.7,45.8,35.4,45.6,35.2z M31.5,33.2c-0.7,0-1.2-0.5-1.2-1.2 s0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2l0,0C32.7,32.7,32.2,33.2,31.5,33.2z M32.7,27.8c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2v-6.6 c0-0.7,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2V27.8z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCaLarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CA-large.ae99326a72d0642f95388b55740d98da.svg";